import { MutationTree } from 'vuex'
import { AuthenticationState, mutationTypes } from '../types'

export const mutations: MutationTree<AuthenticationState> = {
	[mutationTypes.SET_UPDATE_TOKEN_TIMER_ID](state, timerId?: number) {
		state.tokenUpdateTimerId = timerId
	},
}
